import styled from 'styled-components';
import { colors } from 'styles/colors';

export const BigNumbersContainer = styled.div`
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;
  padding: 24px 16px;

  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  align-items: start;

  @media (max-width: 768px) {
    gap: 0;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    margin: 0 -16px;
    overflow-x: hidden;
  }

  overflow-x: auto;
  order: 0;
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 8px;
  text-align: left;
  margin: -12px;

  & > span {
    font-weight: 400;
    color: ${colors.text['white-0']};
  }
`;

export const UnitsTooltipContent = styled(TooltipContent)`
  & > div > span {
    font-size: 14px;
  }

  & > div > span:nth-child(1) {
    font-weight: 500;
    font-size: 16px;
  }
`;

export const GenericDescriptionTooltipContent = styled(TooltipContent)`
  width: 166px;
  height: 50px;

  & > span {
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    text-align: center;
  }
`;

export const HealthyDescriptionTooltipContent = styled(GenericDescriptionTooltipContent)`
  height: 60px;
`;

export const AvailabilityDescriptionTooltipContent = styled(GenericDescriptionTooltipContent)`
  height: 95px;
`;
